/**
 * Componente para el botón de Chat de la navegación inferior
 * Muestra contador de mensajes y notificación visual
 * Adaptado de la versión móvil
 */

import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ChatIcon from '../../Icons/ChatIcon';

const ChatButton = ({ messageCount = 0, disableNavigation = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Determinar si la ruta actual es la de chats
  const isActive = location.pathname === '/chats' || location.pathname.startsWith('/chats/');
  
  // Estado para mostrar etiqueta descriptiva temporalmente
  const [showLabel, setShowLabel] = useState(false);
  
  /**
   * Efecto para manejar la etiqueta descriptiva
   * Muestra "Mensaje/Mensajes" durante 2 segundos cuando cambia el contador
   */
  useEffect(() => {
    if (messageCount > 0) {
      setShowLabel(true);
      const timer = setTimeout(() => {
        setShowLabel(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [messageCount]);
  
  /**
   * Maneja la navegación a la pantalla de chats
   */
  const handlePress = () => {
    if (!disableNavigation) {
      navigate('/chats');
    }
  };
  
  /**
   * Estilo del botón según estado activo
   */
  const buttonStyle = `
    relative flex flex-col items-center justify-center
    w-20 h-12 rounded-full transition-all duration-200
    ${isActive ? 'bg-neutral-700' : 'hover:bg-neutral-800'}
  `;
  
  /**
   * Texto de la etiqueta condicional
   */
  const labelText = showLabel && messageCount > 0 
    ? (messageCount === 1 ? 'Mensaje' : 'Mensajes')
    : '';
  
  return (
    <button
      className={buttonStyle}
      onClick={handlePress}
      aria-label="Ir a chats"
    >
      {/* Icono de chat */}
      <ChatIcon
        active={isActive || messageCount > 0}
        size={28}
        color="#A89CA6"
      />
      
      {/* Indicador de punto rojo cuando hay mensajes */}
      {messageCount > 0 && (
        <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-4 h-2 bg-primary rounded-t-lg" />
      )}
      
      {/* Etiqueta descriptiva temporal */}
      {labelText && (
        <span className="absolute -top-8 bg-primary text-white text-xs px-2 py-1 rounded">
          {labelText}
        </span>
      )}
    </button>
  );
};

export default ChatButton;
